import { render, staticRenderFns } from "./ContentModuleLarge.vue?vue&type=template&id=5ff8812a&scoped=true"
import script from "./ContentModuleLarge.vue?vue&type=script&lang=js"
export * from "./ContentModuleLarge.vue?vue&type=script&lang=js"
import style0 from "./ContentModuleLarge.vue?vue&type=style&index=0&id=5ff8812a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff8812a",
  null
  
)

export default component.exports